<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M10 8a4 4 0 018 0h4.333C23.253 8 24 8.746 24 9.667V14a4 4 0 010 8v4.333c0 .92-.746 1.667-1.667 1.667H18a4 4 0 00-8 0H5.667C4.747 28 4 27.254 4 26.333V22a4 4 0 000-8V9.667C4 8.747 4.746 8 5.667 8H10z"/></svg>
</template>

<script>
export default {
  name: 'objectsPuzzleFilled'
}
</script>
